export default {
    name: 'RepositoryApp'
};
